
export const emptyPaginationState: PaginationState = {
  paginatedTenders: {
    first: 10,
    currentPage: 0,
    filters:
    {
      archived: null,
      startDate: null,
      deadlineDate: null,
      state: null,
      search: null,
      operationalOrgs: null,
      chanceAdmins: null,
      revenue: null,
      surcharge: null,
    },
    sort: null
  },
  paginatedUsers: {
    first: 10,
    currentPage: 0,
    filters: {
      name: "",
      organizationId: null
    }
  },
  paginatedConfigAdministrators: {
    first: 10,
    currentPage: 0,
  },
  paginatedTariffs: {
    first: 10,
    currentPage: 0,
    filters: {
      activeFrom: null,
      province: null
    },
    sort: null
  },
  paginatedSocialSecurity: {
    first: 10,
    currentPage: 0,
    filters: {
      activeFrom: null,
      value: null,
    },
    sort: null
  },
  paginatedHolidays: {
    first: 10,
    currentPage: 0,
    filters: {
      date: null,
      provinces: null
    },
    sort: null
  },
  paginatedLiabilityInsurance: {
    first: 10,
    currentPage: 0,
    filters: {
      activeFrom: null,
      liabilityInsurance: null,
      professionalAssociation: null
    },
    sort: null
  },
  paginatedVacationBonus: {
    first: 10,
    currentPage: 0,
    filters: {
      activeFrom: null,
      bonusAbsolute: null,
      bonusRelative: null,
      provinces: null
    },
    sort: null
  },
  paginatedChristmasBonus: {
    first: 10,
    currentPage: 0,
    filters: {
      activeFrom: null,
      bonusAbsolute: null,
      bonusRelative: null,
      provinces: null
    },
    sort: null
  },
  paginatedVacationDays: {
    first: 10,
    currentPage: 0,
    filters: {
      activeFrom: null,
      lengthOfEmployment: null,
      days: null,
      provinces: null
    },
    sort: null
  },
  paginatedMainOrganizationsWithHierarchy: {
    first: 10,
    currentPage: 0,
  }
};
